import React, { useState } from 'react'
import { connect, useDispatch, useSelector } from 'react-redux'
import { RightArrowIcon, CircleDownIcon, CircleUpIcon } from "../Common/SVGBank"
import ReactDOM from 'react-dom'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faUsers, faHotel, faRuler, faBed } from '@fortawesome/free-solid-svg-icons'
import * as Actions from '../../../redux/actions'
import { fetchMuvRoomsWithRetry } from '../../../utility/utility'
import { priceline_image_boxing, loadingImage, URL_REPLACE } from '../Common/RegExValidate'
import { Image } from 'react-bootstrap';

import Button from '@material-ui/core/Button'
import Icon from '@material-ui/core/Icon';
import { Action } from 'rxjs/internal/scheduler/Action'
import { ActionsObservable } from 'redux-observable'
import { makeStyles } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom"
import { updateHotelPPn, updateOneclickPackageIndex, updatePackageData, updateUseAiHotel } from '../FeaturePage/personalizedTrip/personalizedTrip.slice'
import moment from 'moment'
import { resetFlightPage, updateFlightData } from '../FlightsPage/services/Flights.slice'
import { getFlightsListThunk } from '../FlightsPage/services/Flights.thunks'

import { FetchCachedPullPrice } from '../BookingPage/PaymentPage/payment.thunk'
import { encryptID, getIPFromAmazon, getUserIp } from './hotelServices'
import { CircularProgress } from '@material-ui/core'
import PriceWithSuperscript from '../FlightsPage/flightsComponents'
import { is } from 'date-fns/locale'
import { currencySymbols } from '../MuvBookingPage/MuvExpediaBasicInfo'
import TotalStayCost from '../Common/TotalStayCost'

String.prototype.toProperCase = function () {
    return this.replace(/\w\S*/g, function (txt) { return txt.charAt(0).toUpperCase() + txt.substr(1).toLowerCase(); });
}

const Rooms_ = ({ member, check_in, check_out, establishment, selectedHotel, addHotelItemToCart, addToShoppingCart, fetchMuvRooms, fetchMuvRoomsLight, setOpenAuthModal, hotel_form_state, lang, isMobile, uuid, addBundleToHotelBooking, setHotelBookingState, booking_bundles, booking_info }) => {
    const generalInfo = establishment?.generalInfo;
    const establishmentPricelineID = establishment?.generalInfo?.establishmentPricelineID;
    const room_data = establishment?.generalInfo?.room_data;
    const amenity_data = establishment?.generalInfo?.amenity_data;
    const hotel_id = establishmentPricelineID
    const history = useHistory()
    const oneclick = useSelector(state => state.PersonalizedTrip.oneclick.active)
    const oneclickFlight = useSelector(state => state.PersonalizedTrip.oneclick.flight)
    const packageData = useSelector(state => state.PersonalizedTrip.oneclick.package.data)
    const packageIndex = useSelector(state => state.PersonalizedTrip.oneclick.package.index)
    const dispatch = useDispatch()
    const showRooms = room_data !== undefined ? true : false
    const selectedCurrency = useSelector(state => state.Setting.currency.selected.shortCode);
    const fullCurrency = selectedCurrency ? selectedCurrency.toUpperCase() : "CAD";
    const stayTrip = useSelector(state => state.PersonalizedTrip.stayTrip)
    var searchParams = new URLSearchParams(document.location.search.substring(1));
    const promoCode = searchParams.get("PROMO-CODE" || "promo-code");
    const [hideRooms, setHideRooms] = React.useState(false)
    const cachedHotel = useSelector(state => state.HotelBooking.cachedHotel?.data);
    const useSmop = promoCode && promoCode?.toLowerCase() === "muv";
    const useMer = promoCode && promoCode?.toLowerCase() === "mer";
    const useMobileSmop = promoCode && promoCode?.toLowerCase() === "mob";
    const useAiCode = promoCode && promoCode?.toLowerCase() === "ai";
    const useDiscount = promoCode && promoCode?.toLowerCase()?.includes("9801") ? promoCode?.split('9801')[1] : null;
    const discountAmt = useDiscount ? Number(useDiscount) : null;
    const isXPRoute = document.location.pathname?.includes("xp-hotel");
    const searchRooms = searchParams.get("rooms") || 1;
    let findBy = isXPRoute ? "exp" : searchParams.get("findBy")



    const useCached = (useSmop || useDiscount) && cachedHotel; //disable
    const prepaidCached = useCached && cachedHotel?.payment_type === "prepaid";
    const postpaidCached = useCached && cachedHotel?.payment_type !== "prepaid";
    const cachedSubtotal = cachedHotel && useCached ? Number(cachedHotel?.display_sub_total || 0) : null;
    const prepaidCachedTotal = cachedHotel && prepaidCached ? Number(cachedHotel?.display_sub_total || 0) + Number(cachedHotel?.prepaid_display_total || 0) : 0;
    const cachedTotal = cachedHotel ? cachedHotel?.prepaid_display_total ? Number(cachedHotel?.display_sub_total) + Number(cachedHotel?.prepaid_display_total) : Number(cachedHotel?.display_sub_total) + Number(cachedHotel?.postpaid_display_total) : null;
    const cachedTaxes = cachedHotel && cachedHotel?.prepaid_display_total ? Number(cachedHotel?.prepaid_display_total) : null;
    const [hotelRooms, setHotelRooms] = React.useState(room_data?.room_data)

    const [expHotelRooms, setExpRooms] = React.useState()
    const expContent = expHotelRooms?.muvHotelData?.expContent ? Object.values(expHotelRooms?.muvHotelData?.expContent)?.[0] : null;
    const [loadingRooms, setLoadingRooms] = React.useState(false)
    let currRoomId = ""
    let newRoom = true
    let optionNo = 1
    let prevOptionsNum = 0
    let prevRoomId = ""

    const boardType = {
        NONE: "No breakfast",
        BREAKFAST: "Breakfast",
        ALL_INCLUSIVE: "All inclusive"
    }

    const widthContainer = 300
    const heightContainer = 250

    const useStyles = makeStyles({
        optionsHdr: {
            color: "rgba(0, 0, 0, 1)",
            font: "18px/28px Futura Hv BT",
        },
        optionsRooms: {
            color: "rgba(0, 0, 0, 1)",
            font: "16px/28px Futura Hv BT",
        },
        optionsText: {
            color: "#929292",
            font: "14px/18px Futura Lt BT",
        },
        optionsGreenText: {
            color: "rgba(28, 188, 155, 1)",
            font: "14px/28px Futura Lt BT",
        },
        optionsBtn: {
            //backgroundColor: "rgba(28, 188, 155, 1)",
            color: "rgba(255, 255, 255, 1)",
            font: "14px/14px Futura Hv BT",
            width: "150px",
            height: "44px",
            padding: "14px 22px",
            cursor: "pointer",
            backgroundColor: 'var(--mainGreen)',
        },
        optionBlock: {
            marginLeft: isMobile ? 0 : widthContainer,
        }
    });

    const isLoggedIn = () => {
        return uuid && uuid.length > 0
    }


    const classes = useStyles();

    const populateFlight = (flight) => {
        if (flight) {

            const flights = [
                {
                    "airportFrom": {
                        "country": "",
                        "coordinate": "",
                        "city": flight?.departure_city,
                        "latitude": "",
                        "city_code": flight?.departure_iata,
                        "type": "main",
                        "country_code": "",
                        "cityid_t": "",
                        "state_name": "",
                        "cityid_ppn": "",
                        "rank": "",
                        "cityid_air": "",
                        "state_code": "",
                        "longitude": "",
                        "score": "",
                        "iata": flight?.departure_iata,
                        "airport": "All Airports"
                    },
                    "airportTo": {
                        "country": "",
                        "coordinate": "",
                        "city": flight?.arrival_city,
                        "latitude": "",
                        "city_code": flight?.arrival_iata,
                        "type": "main",
                        "country_code": "",
                        "cityid_t": "",
                        "state_name": "",
                        "cityid_ppn": "",
                        "rank": "",
                        "cityid_air": "",
                        "state_code": "",
                        "longitude": "",
                        "score": "",
                        "iata": flight?.arrival_iata,
                        "airport": "All Airports"
                    },
                    "departureDateFormat": flight?.departure_date ? new Date(moment(flight?.departure_date).format("YYYY-MM-DD 00:00")) : new Date().toDateString(),
                    "departureDate": flight?.departure_date ? new Date(moment(flight?.departure_date).format("YYYY-MM-DD 00:00")) : new Date().toDateString(),
                    "availableSelectDate": new Date().toDateString(),
                    "positionId": "d-0"
                }]
            const numPassengers = flight?.flight_json?.itinerary_data?.length > 0 &&
                flight?.flight_json?.itinerary_data[0]?.price_details?.number_of_passengers;
            const dataToBookingFlights = {
                flightMode: flight?.search_type || 'one_way',
                cabinClass: 'economy',
                numberAdult: numPassengers,
                numberChild: '0',
                flights: flights,
                currency: fullCurrency

            }


            dispatch(updateFlightData(dataToBookingFlights))
            dispatch(resetFlightPage())
            dispatch(getFlightsListThunk(dataToBookingFlights))

            history.push('/flight/search')
        }



    }


    const navigateHotel = (hotel) => {
        const city = hotel?.cityName ? hotel.cityName + ', ' : ""
        const state = hotel?.stateName ? hotel.stateName + ', ' : ""
        const country = hotel?.countryName ? hotel.countryName : ""
        const where = city + state + country;

        let url = ""
        if (hotel?.pricelineCityId) {
            const encryptedId = encryptID(hotel?.pricelineHotelId)
            url = "/hotel-" + hotel?.name.replace(URL_REPLACE, "_") + "-" + encryptedId
                + "?city_id=" + hotel?.pricelineCityId
                + "&check_in=" + hotel?.check_in
                + "&check_out=" + hotel?.check_out
                + "&rooms=" + 1
                + "&guests=" + 1
                + "&hotels=" + hotel?.pricelineHotelId
                + "&city_lat=" + hotel?.latitude
                + "&city_lng=" + hotel?.longitude
                + "&where=" + (where.replace(URL_REPLACE, "_"))

            if (hotel?.ppn_bundle) {
                url += "&ppn_bundle=" + hotel?.ppn_bundle
            }
        }
        history.push(url.toLowerCase());
    }




    const handleAddRoomToBooking = async ({ lang, uuid, trip_id, hotel_id, ppn_book_bundle, check_in, check_out, rooms, adults, booking_bundles, rate, room }) => {

        // if booking_info.establishmentPricelineID !== hotel_id then clear booking
        /*   if(booking_info.establishmentPricelineID !== undefined && booking_info.establishmentPricelineID !== hotel_id) {
               console.log("clear");
               //clearHotelBooking();
               booking_bundles=[]
               setHotelBookingState({
                   hotel_id, 
                   ppn_book_bundle, 
                   check_in, 
                   check_out, 
                   rooms,
                   adults
               })
           }
           */

        addBundleToHotelBooking({ hotel_id, ppn_book_bundle, check_in, check_out, rooms, adults, booking_bundles })


        //setHotelEstablishmentId(pricelineId)
        //setSwitchContainer(member_area_router.establishment)

        if (useAiCode) {
            dispatch(updateUseAiHotel(true))
        }
        if (oneclick) {
            const hotelPackages = packageData && packageData?.length > 0 ? packageData?.filter((data) => data?.type === "hotel") : null
            if (packageData && packageIndex <= packageData?.length - 1) { //continue loop
                const nextIndex = packageIndex + 1;
                let updatePackage = packageData.map(a => ({ ...a }));;

                if (ppn_book_bundle) {
                    updatePackage[packageIndex]["ppn_book_bundle"] = ppn_book_bundle;
                    dispatch(updatePackageData(updatePackage)) ///add ppn bundle
                }

                dispatch(updateOneclickPackageIndex(nextIndex))
                const nextData = packageData[nextIndex];

                if (nextData?.type === "hotel") {
                    navigateHotel(nextData)
                }
                if (nextData?.type === "flight") {
                    populateFlight(nextData)
                }

            }



            // if (oneclick && ppn_book_bundle && oneclickFlight) {
            //     dispatch(updateHotelPPn(ppn_book_bundle))
            //     populateFlight()
            // }
        }

        else {

            if (useOTP || useSmop || useMer || useDiscount || useAiCode) {

                const data = {
                    hotelid_ppn: hotel_id,
                    check_in: hotel_form_state.check_in,
                    check_out: hotel_form_state.check_out
                }

                if (hotel_id) {
                    dispatch(FetchCachedPullPrice(data)) ///

                }



                history.push("/booking"
                    + (trip_id ? "-" + trip_id : "")
                    + "?check_in=" + hotel_form_state.check_in
                    + "&check_out=" + hotel_form_state.check_out
                    + "&rooms=" + (hotel_form_state.rooms ? hotel_form_state.rooms : 1)
                    + "&adults=" + (hotel_form_state.adults ? hotel_form_state.adults : 1)
                    + (ppn_book_bundle ? "&ppn_book_bundle=" + ppn_book_bundle : "")
                    + "&rate=smop")
            }

            else {
                history.push("/booking"
                    + (trip_id ? "-" + trip_id : "")
                    + "?check_in=" + hotel_form_state.check_in
                    + "&check_out=" + hotel_form_state.check_out
                    + "&rooms=" + (hotel_form_state.rooms ? hotel_form_state.rooms : 1)
                    + "&adults=" + (hotel_form_state.adults ? hotel_form_state.adults : 1)
                    + (ppn_book_bundle ? "&ppn_book_bundle=" + ppn_book_bundle : ""))
            }


        }


    }

    const bookHPRoom = async (room) => {
        if (findBy === "hp") {
            //new shopping cart page
            const resultCart = await addToShoppingCart(uuid || "TMPUUID");
            const cartId = resultCart?.cart_uuid;


            const hotelInfo = generalInfo?.room_data ?? {};
            const hotelState = hotel_form_state ?? {}
            const hotelId = generalInfo?.room_data?.hotelplanner_id;
            const ipAddress = await getUserIp();

            const data = {
                // muv_hotel_id: hotelId,
                check_in: hotel_form_state?.check_in,
                check_out: hotel_form_state?.check_out,
                provider: "hp",
                rooms: hotel_form_state?.rooms || 1,
                adults: hotel_form_state?.adults || 1,
                children: 0,
                userIp: ipAddress || "138.1.1.1",
                userAgent: "MUV"
            }

            const checkInInfo = { muvHotel: hotelInfo, ...data }
            if (cartId) {
                await addHotelItemToCart({
                    uuid: uuid || "TMPUUID",
                    id: hotelId,
                    cart_uuid: cartId,
                    room_id: room?.id,
                    provider: findBy,
                    providerCartUniqueId: "",
                    price: room?.rates?.display_total,
                    currency: room?.rates?.display_currency,
                    checkIn: hotel_form_state.check_in,
                    checkOut: hotel_form_state.check_out,
                    bundleId: room?.rates?.bundle,
                    roomData: JSON.stringify(room),
                    checkInInfo: JSON.stringify(checkInInfo)
                })

                ///goto shopping cart page
                if (cartId) {
                    history.push(`/muv-booking?cart_uuid=${cartId}`)
                }
            }

        }
    }


    const bookExpediaRoom = async (rate, roomInfo, taxTotal, baseRate, total, currency) => {

        if (findBy === "exp") {
            //new shopping cart page
            const resultCart = await addToShoppingCart(uuid || "TMPUUID");
            const cartId = resultCart?.cart_uuid;


            const hotelInfo = generalInfo?.room_data ?? {};
            const hotelState = hotel_form_state ?? {}
            const hotelId = generalInfo?.room_data?.id;
            const ipAddress = await getUserIp();

            const data = {
                // muv_hotel_id: hotelId,
                check_in: hotel_form_state?.check_in,
                check_out: hotel_form_state?.check_out,
                provider: "hp",
                rooms: hotel_form_state?.rooms || 1,
                adults: hotel_form_state?.adults || 1,
                children: 0,
                userIp: ipAddress || "138.1.1.1",
                userAgent: "MUV"
            }


            const checkInfo = {
                address: expContent?.address,
                brand: expContent?.brand,
                checkin: expContent?.checkin,
                checkout: expContent?.checkout,
                images: [expContent?.images?.[0]] || null,
                name: expContent?.name,
                phone: expContent?.phone,
                fees: expContent?.fees,
                // rates: expContent?.rates,
                ratings: expContent?.ratings,
                // rooms: expContent?.rooms
            };

            const general = {
                ...generalInfo,
                amenities: [],
                amenity_data: [],
                hotel_data: {
                    ...generalInfo?.hotel_data,
                    amenity_data: [],
                    review_data: [],
                    review_data_exp: [],
                },
                room_data: {
                    ...generalInfo?.room_data,
                    amenity_data: [],
                    review_data: [],
                    review_data_exp: [],
                }
            }
            const room = {
                ...roomInfo,
                amenities: {}
            }

            const checkInInfo = {
                muvHotel: {
                    generalInfo: general,
                    roomInfo: room,
                    checkInfo: checkInfo
                },
                ...data,

            }





            if (cartId) {
                await addHotelItemToCart({
                    uuid: uuid || "TMPUUID",
                    id: hotelId,
                    cart_uuid: cartId,
                    room_id: rate?.id,
                    provider: findBy,
                    providerCartUniqueId: "",
                    price: baseRate,
                    currency: fullCurrency || "",
                    checkIn: hotel_form_state.check_in,
                    checkOut: hotel_form_state.check_out,
                    // bundleId: room?.rates?.bundle,
                    roomData: JSON.stringify(rate),
                    checkInInfo: JSON.stringify(checkInInfo),
                })

                ///goto shopping cart page
                if (cartId) {
                    history.push(`/muv-booking?cart_uuid=${cartId}`)
                }
            }

        }
    }




    function randomIntFromInterval(min, max) { // min and max included 
        return Math.floor(Math.random() * (max - min + 1) + min)
    }


    const photos = room_data?.photo_data;

    const defaultVals = hotelRooms ? Array.from(Array(hotelRooms.length).keys(), n => 2) : null;
    const [rateLimit, setRateLimit] = React.useState(defaultVals);
    const [selectedOption, setSelectedOption] = React.useState(null);

    const AMENITY_COUNT = 5;
    const [amenityLimit, setAmenityLimit] = React.useState(AMENITY_COUNT);


    const changeAmenityLimit = (limit) => {
        setAmenityLimit(limit)
    }

    const openPopup = () => {
        setOpenAuthModal(true)
    }

    const dateInPast = (firstDate, secondDate) =>
        firstDate.setHours(0, 0, 0, 0) < secondDate.setHours(0, 0, 0, 0);

    const pastDate = hotel_form_state?.check_in ? dateInPast(new Date(moment(hotel_form_state.check_in)), new Date()) : false;




    const sortRoomsByPrice = () => {
        if (findBy === "pl") {
            let copyRooms = hotelRooms?.length > 0 ? [...hotelRooms] : [];
            const isLoggedin = isLoggedIn()

            copyRooms.forEach((room) => {
                if (isLoggedin || useSmop) {
                    room['rate_data'] = room?.rate_data?.sort((a, b) => a?.price_details?.display_all_in_total - b?.price_details?.display_all_in_total)
                }
                else { //sort logged out
                    room['rate_data'] = room?.rate_data?.sort((a, b) => {
                        if (a?.rate_type === "MER" && b?.rate_type === "MER") {
                            return a?.price_details?.display_all_in_total - b?.price_details?.display_all_in_total
                        }
                        return a?.benchmark_price_details?.display_price - b?.benchmark_price_details?.display_price
                    })
                }

            }) ///sort rate



            //sort rooms
            if (isLoggedin || useSmop) {
                copyRooms = copyRooms?.sort((a, b) => a?.rate_data[0]?.price_details?.display_all_in_total - b?.rate_data[0]?.price_details?.display_all_in_total)
            }
            else { //sort logged out
                copyRooms = copyRooms?.sort((a, b) => {
                    if (a?.rate_data[0]?.rate_type === "MER" && b?.rate_data[0]?.rate_type === "MER") {
                        return a?.rate_data[0]?.price_details?.display_all_in_total - b?.rate_data[0]?.price_details?.display_all_in_total
                    }
                    return a?.rate_data[0]?.benchmark_price_details?.display_price - b?.rate_data[0]?.benchmark_price_details?.display_price
                })



            }





            return copyRooms;
        }
    }

    const sortedRooms = sortRoomsByPrice();



    const useOTP = promoCode && promoCode?.toLowerCase() === "otp";


    // React.useEffect(() => {
    //     if (hotelRooms && hotelRooms?.length > 0) {
    //         let smop = false;
    //         hotelRooms.forEach((room) => {
    //             const rates = room?.rate_data || [];

    //             rates.forEach((rate) => {
    //                 if (rate?.rate_type === "SMOP") {
    //                     smop = true;
    //                 }
    //             })
    //         }
    //         )
    //         const hide = smop && !isLoggedIn() && useOTP
    //         setHideRooms(hide)
    //     }
    // }, [hotelRooms])


    React.useEffect(() => {
        const hpId = establishment?.generalInfo?.room_data?.hotelplanner_id;

        if ((hotel_id && hotel_id?.length > 0) || hpId || selectedHotel) {
            const fetchRooms = async () => {
                if (findBy === "hp" || findBy === "exp") {
                    setLoadingRooms(true)
                    const hotelId = generalInfo?.room_data?.hotelplanner_id;

                    const ipAddress = await getUserIp();
                    let rooms;




                    if (findBy === "exp") {
                        const data = {
                            muv_hotel_id: selectedHotel,
                            check_in: check_in,
                            check_out: check_out,
                            provider: 'exp',
                            adults: hotel_form_state?.adults || 1,
                            children: 0,
                            currency: fullCurrency,
                            userIp: ipAddress || "138.1.1.1",
                            rooms: hotel_form_state?.rooms || 1,
                            userAgent: navigator?.userAgent || "MUV",
                            customerPlatform: isMobile ? "mobile" : "web",
                            uuid: uuid
                        }
                        rooms = await fetchMuvRoomsWithRetry(fetchMuvRoomsLight, data, "exp");


                        setExpRooms(rooms)
                    }
                    if (findBy === "hp") {
                        const data = {
                            muv_hotel_id: selectedHotel,
                            check_in: hotel_form_state?.check_in,
                            check_out: hotel_form_state?.check_out,
                            provider: findBy,
                            rooms: hotel_form_state?.rooms || 1,
                            adults: hotel_form_state?.adults || 1,
                            children: 0,
                            userIp: ipAddress || "138.1.1.1",
                            userAgent: navigator?.userAgent || "MUV",
                            customerPlatform: isMobile ? "mobile" : "web",
                            uuid: uuid || "TMPUUID"
                        }
                        rooms = await fetchMuvRoomsWithRetry(fetchMuvRooms, data, "hp")
                        setHotelRooms(rooms?.roomData ?? [])
                    }






                    setLoadingRooms(false)
                }


            }
            fetchRooms()
        }
    }, [hotel_id, findBy, uuid])

    React.useEffect(() => {
        if (uuid && uuid.length > 0) {
            setHideRooms(false)
        }
    }, [uuid]) //signs in 


    if (hideRooms) {
        return null
    } //dont show rooms until logged in


    const toggleRateLimit = (idx) => {
        setSelectedOption((oldId) => {
            return idx === oldId ? null : idx;
        })

    }

    const expRooms = expContent?.rooms ? Object.values(expContent?.rooms) : [];

    const expRawData = expHotelRooms?.roomData?.[0]?.rooms ?? []


    function getLowestRateValue(rate) {
        if (!rate?.occupancy_pricing) return Infinity;

        // Get all occupancy keys (e.g., "2", "3", "4")
        const keys = Object.keys(rate.occupancy_pricing);
        if (!keys.length) return Infinity;

        // Find the lowest total.inclusive.request_currency.value among them
        let lowest = Infinity;
        for (const key of keys) {
            const val = parseFloat(
                rate.occupancy_pricing[key]?.totals?.inclusive?.request_currency?.value
            );
            if (!isNaN(val) && val < lowest) {
                lowest = val;
            }
        }

        return lowest;
    }

    function sortRoomsByLowestRate(rooms) {
        if (!Array.isArray(rooms)) return [];

        const toArray = (rates) => {
            if (Array.isArray(rates)) return rates;
            if (rates == null) return [];
            // if a single rate object, wrap it
            return typeof rates === 'object' ? [rates] : [];
        };

        const cleanedRooms = rooms.map((room) => {
            const ratesArr = toArray(room.rates);

            // Decide whether to exclude unpriceable rates:
            const validRates = ratesArr
                // keep this filter if you want to drop unpriceable rates
                .sort((a, b) => getLowestRateValue(a) - getLowestRateValue(b));

            return { ...room, rates: validRates };
        });

        // If you DON'T want to remove rooms with no valid rates, skip this filter.
        // const nonEmptyRooms = cleanedRooms.filter((r) => r.rates.length > 0);


        return cleanedRooms.sort(
            (a, b) => getLowestRateValue(a.rates?.[0]) - getLowestRateValue(b.rates?.[0])
        );
    }



    const expRoomData = sortRoomsByLowestRate(expRawData);


    return (
        <div>

            {loadingRooms ? <div>
                <div style={{ width: "100%", textAlign: "center" }}>
                    <CircularProgress
                        disableShrink
                        size={40}
                        style={{

                            color: "var(--mainGreen)",
                            textAlign: "right",
                            marginTop: "15px",
                            marginRight: "5px",
                        }} />

                </div>

            </div> :
                <div>

                    <div>
                        {(findBy === "hp") ?
                            <div style={{ font: "16px/18px Futura Md BT", color: "#000000" }}>
                                {hotelRooms?.length > 0 && <div style={{ font: "24px/16px Futura Hv BT", color: "#000000" }}>Choose Room</div>}
                                {hotelRooms?.length === 0 && <div style={{ font: "24px/36px Futura Hv BT", color: "var(--lightGray)", textAlign: "center", marginTop: 0 }}>
                                    {pastDate ? "Check-in date has passed. Please select a future date." : "There are no rooms available at these dates"}
                                </div>}
                                {hotelRooms?.length > 0 &&
                                    hotelRooms?.map((room) => {
                                        return (
                                            <div key={room?.id} >
                                                <div
                                                    style={{
                                                        display: "flex"
                                                    }}>
                                                    <div>
                                                        <div style={{ font: "18px/24px Futura Hv BT", color: "#000000", marginBottom: 10, marginTop: 20 }}>{room?.title?.replace(".", "")}</div>
                                                        {room?.images && room?.images?.length > 0 && <div style={{ width: widthContainer, }}>
                                                            <Image style={{ objectFit: "cover", objectPosition: "center", width: widthContainer, height: heightContainer }}
                                                                alt="establishment" src={room?.images[0] ||
                                                                    "https://amhqajbken.cloudimg.io/v7/_muvestab_/000_c…on/grayBackgroundCamera.jpg?func=crop&w=359&h=300"}
                                                            />
                                                        </div>}
                                                    </div>

                                                    <div style={{
                                                        marginLeft: 20,
                                                        marginTop: 50
                                                    }}>

                                                        {room && room?.description &&
                                                            <div dangerouslySetInnerHTML={{ __html: room?.description }} style={{ font: "16px/24px Futura Lt BT", color: "#929292", marginBottom: 10 }} />}
                                                        <div>

                                                            {room?.sq_foot && <React.Fragment>
                                                                <FontAwesomeIcon icon={faRuler} style={{ marginLeft: "15px", marginRight: "5px" }} /><span className={classes.optionsRooms}>{room.sq_foot + " sq ft"}</span>
                                                            </React.Fragment>}
                                                            {/* {averageSleeps > 0 && <React.Fragment>
                                                <FontAwesomeIcon icon={faUsers} style={{ marginLeft: "15px", marginRight: "5px" }} /><span className={classes.optionsRooms}>Sleeps {Math.round(averageSleeps)}</span>
                                            </React.Fragment>} */}


                                                        </div>
                                                    </div>

                                                </div>
                                                <div style={{
                                                    display: "flex",
                                                    justifyContent: "flex-end",
                                                    marginRight: 20
                                                }}>

                                                    <div style={{ font: "16px/28px Futura Hv BT", paddingRight: 10, textAlign: 'right' }}>
                                                        {room?.rates?.display_symbol + (room?.rates?.display_sub_total?.toFixed(2))}
                                                        <div className={classes.optionsText} style={{ marginTop: -6, font: "14px/28px Futura Lt BT" }}>
                                                            +{room?.rates?.display_symbol}{Number(room?.rates?.tax).toFixed(2)} taxes & fees</div>
                                                    </div>


                                                    <div onClick={() => { bookHPRoom(room) }}

                                                        className={classes.optionsBtn}
                                                        style={{ display: "flex", height: 50, marginTop: 5 }} >Book <RightArrowIcon width={15} height={15} style={{ marginLeft: "40px" }} /></div>
                                                </div>

                                            </div>
                                        )
                                    })}

                            </div>


                            : findBy === 'exp' ?
                                <div style={{ font: "16px/18px Futura Md BT", color: "#000000" }}>
                                    {expRoomData?.length > 0 && <div style={{ font: "24px/16px Futura Hv BT", color: "#000000" }}>Choose Room</div>}
                                    {expRoomData?.length === 0 && <div style={{ font: "24px/36px Futura Hv BT", color: "var(--lightGray)", textAlign: "center", marginTop: 0 }}>
                                        {pastDate ? "Check-in date has passed. Please select a future date." : "There are no rooms available at these dates"}
                                    </div>}
                                    {expRoomData?.length > 0 &&
                                        expRoomData?.map((room, idx) => {


                                            //  const roomRate = room?.id && expHotelRooms?.roomData?.rooms ? expHotelRooms?.roomData?.rooms?.find((rate) => rate?.id === room?.id) : null
                                            const roomInfo = expContent?.rooms[room?.id] ?? null
                                            const roomAmenities = roomInfo?.amenities ? Object.values(roomInfo?.amenities) : [];
                                            const description = room?.rates?.length > 0 ? Object.values(room?.rates?.[0]?.bed_groups)?.[0]?.description : ""


                                            return (
                                                <div key={room?.id} style={{
                                                    marginLeft: idx === 0 ? -28 : 0,

                                                }}>


                                                    <React.Fragment>


                                                        <div style={{ width: "100%", height: 30, float: "none", clear: "both", borderBottom: idx !== 0 ? "2px solid rgb(232, 232, 232)" : "0px none", marginBottom: 15 }}></div>




                                                    </React.Fragment>

                                                    <div>




                                                        {room && room?.rates && room?.rates?.slice(0, selectedOption === idx ? room?.rates?.length : 2)?.map((rate, indexRate) => {

                                                            const rateAmenities = rate?.amenities ? Object.values(rate?.amenities) : [];
                                                            const rateCost = Object.values(rate?.occupancy_pricing)?.[0]

                                                            // Add null check for rateCost to prevent NaN calculations
                                                            if (!rateCost) {
                                                                console.warn("No rate cost data available for room:", room?.name);
                                                                return null;
                                                            }


                                                            const rateDays = rateCost?.nightly?.length ?? 1;
                                                            const days = Math.max(rateDays, 1); // Ensure days is at least 1 to prevent division by zero
                                                            const roomsSelected = hotel_form_state?.rooms || 1;
                                                            let strikethroughPrice = Number(rateCost?.totals?.strikethrough?.request_currency?.value);
                                                            let memberRate = rate?.member_deal_available;


                                                            const specialPrice = isLoggedIn() && strikethroughPrice && memberRate;
                                                            const signInforSpecial = !isLoggedIn() && memberRate;
                                                            let ratePriceText = specialPrice ? "müver special price" : signInforSpecial ? "sign in for müver special price" : "";
                                                            let rateTextColor = specialPrice ? "#0D3A7D" : signInforSpecial ? "#19BC9B" : "#929292";
                                                            const isNorthAmerica =
                                                                ["US", "CA", "MX", "USA", "CAN", "MEX"].includes(
                                                                    generalInfo?.hotel_data?.city?.MuvMetaCity?.country_code
                                                                    ?? generalInfo?.hotel_data?.city?.MuvMetaCity?.country
                                                                    ?? generalInfo?.countryCode
                                                                    ?? generalInfo?.countryName
                                                                );


                                                            let currency = ''

                                                            const propertyFees = Number(rateCost?.totals?.property_fees?.request_currency?.value ?? 0) ?? 0;

                                                            const baseRate = Number(rateCost?.totals?.exclusive?.request_currency?.value ?? 0);
                                                            const totalCost = Number((rateCost?.totals?.property_inclusive?.request_currency?.value || rateCost?.totals?.inclusive?.request_currency?.value) ?? 0);
                                                            const postPaid = Number(rateCost?.totals?.property_inclusive?.request_currency?.value ?? 0) - Number(rateCost?.totals?.inclusive?.request_currency?.value ?? 0)
                                                            const baseRateNorthAmerica = Number(rateCost?.totals?.exclusive?.request_currency?.value ?? 0) + postPaid;
                                                            const taxTotal = totalCost - (isNorthAmerica ? baseRateNorthAmerica : baseRate);


                                                            // Add validation to prevent NaN calculations
                                                            const allInTotal = isNaN(baseRate) || baseRate === 0 ? 0 : Number(((isNorthAmerica ? baseRateNorthAmerica : baseRate) / days).toFixed(2));
                                                            strikethroughPrice = isNaN(strikethroughPrice) || strikethroughPrice === 0 ? 0 : Number((Number(strikethroughPrice + postPaid) / days).toFixed(2));




                                                            try {
                                                                const allItems = Array.isArray(rateCost?.nightly)
                                                                    ? rateCost.nightly.flat()
                                                                    : [];


                                                                if (!Array.isArray(allItems) || allItems.length === 0) {
                                                                    console.warn("No valid rate data available.");

                                                                }



                                                            } catch (err) {
                                                                console.error("Error parsing rate cost data:", err);
                                                            }


                                                            const taxes = Number((taxTotal) / days).toFixed(2);


                                                            const renderCancellationPolicy = (policy) => {
                                                                try {
                                                                    if (!Array.isArray(policy) || policy.length === 0) return null;

                                                                    const item = policy[0];
                                                                    const start = item?.start;
                                                                    const end = item?.end;
                                                                    const currency = item?.currency || 'USD';



                                                                    const startDate = moment(start).isValid()
                                                                        ? moment(start).format("dddd, MMMM D")
                                                                        : null;
                                                                    const endDate = moment(end).isValid()
                                                                        ? moment(end).format("dddd, MMMM D")
                                                                        : null;

                                                                    if (!startDate || !endDate

                                                                    ) return null;

                                                                    const startMoment = moment(start);

                                                                    // Get user's local timezone abbreviation
                                                                    const getUserTimezoneAbbr = (date) => {
                                                                        const formatOptions = { timeZoneName: 'short' };
                                                                        const formatter = new Intl.DateTimeFormat(undefined, formatOptions);
                                                                        const parts = formatter.formatToParts(date.toDate());
                                                                        const tzPart = parts.find(part => part.type === 'timeZoneName');
                                                                        return tzPart ? tzPart.value : '';
                                                                    };

                                                                    const abbr = getUserTimezoneAbbr(startMoment);


                                                                    const hasPassed = startMoment.isBefore(moment());

                                                                    const cancelUntil = startMoment.format(`MMMM Do [@] h:mm A`) + ` ${abbr}` + (hasPassed ? " (date passed)" : "");
                                                                    return (
                                                                        <div

                                                                            style={{

                                                                                // padding: 20,
                                                                                paddingTop: 0,
                                                                                color: "var(--mainGrey)",
                                                                                font: "14px/20px Futura Lt BT",
                                                                            }}
                                                                        >
                                                                            {!rate?.refundable ? <span >This rate is non-refundable.</span> : <span>Free cancellation until <strong>{cancelUntil}</strong>.</span>}
                                                                            {/* After that, a cancellation fee equal to one night’s stay may apply ({currency}). */}
                                                                            {/* <br />
                                                                            Stay dates: {startDate} to {endDate}. */}
                                                                        </div>
                                                                    );
                                                                } catch (err) {
                                                                    console.error("Error rendering cancellation policy:", err);
                                                                    return null;
                                                                }
                                                            };

                                                            return (
                                                                <div className={""} style={{
                                                                    border: indexRate === 0 && idx === 0 ? "2px solid var(--mainGreen)" : "none",
                                                                    padding: indexRate === 0 && idx === 0 ? 30 : 0,
                                                                    marginBottom: 20
                                                                }} key={indexRate} >
                                                                    {/* Room Header - Only show for first option - Above everything */}
                                                                    {indexRate === 0 && (
                                                                        <div style={{ marginBottom: 15 }}>
                                                                            <div style={{ font: "18px/24px Futura Hv BT", color: "#000000", marginBottom: 10 }}>
                                                                                {room?.room_name?.replace(".", "")}
                                                                            </div>
                                                                            <div style={{ font: "16px/24px Futura Lt BT", color: "#000000", marginBottom: 10 }}>
                                                                                {description}
                                                                            </div>
                                                                            <div>
                                                                                {roomInfo?.area?.square_feet > 0 && (
                                                                                    <React.Fragment>
                                                                                        <FontAwesomeIcon icon={faRuler} style={{ marginLeft: "15px", marginRight: "5px" }} />
                                                                                        <span className={classes.optionsRooms}>{roomInfo?.area?.square_feet + " sq ft"}</span>
                                                                                    </React.Fragment>
                                                                                )}
                                                                                {roomInfo?.occupancy?.max_allowed?.total > 0 && (
                                                                                    <React.Fragment>
                                                                                        <FontAwesomeIcon icon={faUsers} style={{ marginLeft: "15px", marginRight: "5px" }} />
                                                                                        <span className={classes.optionsRooms}>Sleeps {Math.round(roomInfo?.occupancy?.max_allowed?.total)}</span>
                                                                                    </React.Fragment>
                                                                                )}
                                                                            </div>
                                                                        </div>
                                                                    )}

                                                                    {/* Main Content Area */}
                                                                    <div style={{
                                                                        display: "flex",
                                                                        flexDirection: isMobile ? "column" : "row",
                                                                        alignItems: isMobile ? "stretch" : "flex-start",
                                                                        paddingRight: idx === 0 && indexRate === 0 ? 0 : 25
                                                                    }}>
                                                                        {/* Room Image - Left Side - Only for first option */}
                                                                        {roomInfo?.images && roomInfo?.images?.length > 0 && indexRate === 0 && (
                                                                            <div style={{
                                                                                width: isMobile ? "100%" : widthContainer,
                                                                                marginRight: isMobile ? 0 : 20,
                                                                                marginBottom: isMobile ? 15 : 0,
                                                                                flexShrink: 0
                                                                            }}>
                                                                                <Image
                                                                                    style={{
                                                                                        objectFit: "cover",
                                                                                        objectPosition: "center",
                                                                                        width: "100%",
                                                                                        height: isMobile ? 200 : heightContainer
                                                                                    }}
                                                                                    alt="room"
                                                                                    src={roomInfo?.images?.[0]?.links["1000px"]?.href ||
                                                                                        "https://amhqajbken.cloudimg.io/v7/_muvestab_/000_c…on/grayBackgroundCamera.jpg?func=crop&w=359&h=300"}
                                                                                />
                                                                            </div>
                                                                        )}

                                                                        {/* Room Content - Right Side */}
                                                                        <div style={{
                                                                            flex: 1,
                                                                            display: "flex",
                                                                            flexDirection: "column",
                                                                            alignItems: "stretch",
                                                                            marginLeft: isMobile ? 0 : (indexRate === 0 ? 0 : widthContainer + 20),
                                                                            width: isMobile ? "100%" : "auto"
                                                                        }}>
                                                                            {/* Option Header */}
                                                                            <div style={{
                                                                                font: "18px/28px Futura Hv BT",
                                                                                color: "#000000",
                                                                                marginBottom: 15
                                                                            }}>
                                                                                Option {indexRate + 1}
                                                                            </div>

                                                                            {/* Rate Details and Amenities */}
                                                                            <div style={{
                                                                                display: "flex",
                                                                                gap: isMobile ? 10 : 20,
                                                                                marginBottom: 15,
                                                                                width: "100%"
                                                                            }}>
                                                                                {/* Rate Amenities */}
                                                                                <div style={{
                                                                                    width: isMobile ? "50%" : "30%",
                                                                                    marginBottom: isMobile ? 15 : 0,
                                                                                    display: "block",
                                                                                    maxWidth: isMobile ? "50%" : "30%",
                                                                                    minWidth: isMobile ? "50%" : "30%"
                                                                                }}>
                                                                                    <div><span className={classes.optionsText}>{"Pay now"}</span></div>
                                                                                    {rateAmenities &&
                                                                                        rateAmenities?.map((amenity, index) => {
                                                                                            return (
                                                                                                <div key={index + "amen"}><span className={classes.optionsText}>{amenity?.name}</span></div>
                                                                                            )
                                                                                        })}
                                                                                    <div><span className={classes.optionsText}>{rate?.refundable ? "Cancellable" : "Non-Cancellable"}</span></div>
                                                                                    <div><span className={classes.optionsText}>{rate.refundable ? "Refundable" : "Non-Refundable"}</span></div>
                                                                                </div>

                                                                                {/* Room Amenities */}
                                                                                <div className={classes.optionsText} style={{
                                                                                    width: isMobile ? "50%" : "30%",
                                                                                    textTransform: "capitalize",
                                                                                    marginBottom: isMobile ? 15 : 0,
                                                                                    display: "block",
                                                                                    maxWidth: isMobile ? "50%" : "30%",
                                                                                    minWidth: isMobile ? "50%" : "30%"
                                                                                }}>
                                                                                    {roomAmenities !== undefined && roomAmenities !== null && roomAmenities?.length > 0 && roomAmenities?.slice(0, amenityLimit).map((amenity, i) => {
                                                                                        return (<div key={i} style={{ textTransform: "capitalize" }}>{amenity?.name?.toLowerCase()}</div>)
                                                                                    })}
                                                                                    {roomAmenities?.length > AMENITY_COUNT && <div onClick={() => {
                                                                                        changeAmenityLimit(amenityLimit === AMENITY_COUNT ? roomAmenities?.length : AMENITY_COUNT);
                                                                                    }} style={{ color: "var(--mainGreen)", cursor: "pointer", marginTop: 5, }}> {amenityLimit === AMENITY_COUNT ? "more" : "less"}</div>}
                                                                                </div>
                                                                            </div>

                                                                            {/* Price and Booking Section */}
                                                                            <div style={{
                                                                                display: isMobile ? "block" : "flex",
                                                                                justifyContent: isMobile ? "flex-end" : "space-between",
                                                                                alignItems: "flex-end",
                                                                                marginTop: "auto"
                                                                            }}>
                                                                                <div style={{
                                                                                    marginBottom: isMobile ? 10 : 0,
                                                                                    textAlign: isMobile ? "right" : "left"
                                                                                }}>
                                                                                    <div className={classes.optionsGreenText}>
                                                                                        {rate.available_rooms ? `We have ${rate.available_rooms} rooms left` : ""}
                                                                                        {renderCancellationPolicy(rate?.cancel_penalties)}
                                                                                    </div>
                                                                                    {/* Cancellation Policy - Right under the "We have X rooms left" text */}

                                                                                </div>

                                                                                <div style={{
                                                                                    display: isMobile ? "block" : "flex",
                                                                                    alignItems: "center",
                                                                                    gap: 15,
                                                                                    textAlign: isMobile ? "right" : "left"
                                                                                }}>
                                                                                    {/* Price */}
                                                                                    <div style={{
                                                                                        textAlign: isMobile ? "right" : "right",
                                                                                        marginBottom: isMobile ? 10 : 0
                                                                                    }}>
                                                                                        <span className={classes.optionsHdr}>
                                                                                            {strikethroughPrice > 0 && (
                                                                                                <span style={{ font: "14px/28px Futura Lt BT", color: 'red', textDecoration: 'line-through', marginRight: 12 }}>
                                                                                                    ${(strikethroughPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))}
                                                                                                </span>
                                                                                            )}
                                                                                            <span>
                                                                                                {currencySymbols?.[fullCurrency] || "$"}
                                                                                                <PriceWithSuperscript amount={allInTotal} style={{
                                                                                                    font: "18px/28px Futura Md BT",
                                                                                                }} />
                                                                                            </span><span style={{ font: "14px/28px Futura Lt BT" }}>/night</span>
                                                                                        </span>
                                                                                        {taxes > 0 && (
                                                                                            <div className={classes.optionsText} style={{ marginTop: -6 }}>
                                                                                                +{'$'}{Number(taxes).toFixed(2)} taxes & fees
                                                                                            </div>
                                                                                        )}
                                                                                        <div className={classes.optionsText} onClick={() => signInforSpecial ? openPopup() : null} style={{ color: rateTextColor, cursor: signInforSpecial ? "pointer" : "auto" }}>
                                                                                            {ratePriceText}
                                                                                        </div>
                                                                                        <TotalStayCost totalAmount={totalCost * searchRooms} rooms={roomsSelected} nights={days} currencySymbol={currencySymbols?.[fullCurrency] || "$"} />
                                                                                    </div>

                                                                                    {/* Book Button */}
                                                                                    <div onClick={() => bookExpediaRoom(rate, roomInfo, taxTotal, baseRate, allInTotal, currency)}
                                                                                        className={classes.optionsBtn}
                                                                                        style={{
                                                                                            opacity: 1,
                                                                                            display: "flex",
                                                                                            height: 50,
                                                                                            alignItems: "center",
                                                                                            justifyContent: "center",
                                                                                            minWidth: 120,
                                                                                            marginLeft: isMobile ? "auto" : 0
                                                                                        }}>
                                                                                        Book <RightArrowIcon width={15} height={15} style={{ marginLeft: "10px" }} />
                                                                                    </div>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}

                                                        {room?.rates && room?.rates?.length > 2 && <div className="" style={{
                                                            color: "var(--mainGreen)",
                                                            marginLeft: isMobile ? 0 : 317, marginTop: isMobile ? 15 : "5px"
                                                        }}>
                                                            {selectedOption === idx && <div style={{ cursor: "pointer" }} onClick={() => toggleRateLimit(idx)}> <CircleUpIcon /> Hide more options</div>}
                                                            {selectedOption !== idx && <div style={{ cursor: "pointer" }} onClick={() => toggleRateLimit(idx)}> <CircleDownIcon /> Show more options</div>}
                                                        </div>}


                                                    </div>


                                                </div>
                                            )
                                        })}

                                </div>
                                : <div style={{ font: "16px/18px Futura Md BT", color: "#000000" }}>
                                    {showRooms && sortedRooms?.length > 0 && <div style={{ font: "24px/16px Futura Hv BT", color: "#000000" }}>Choose Room</div>}
                                    {showRooms && sortedRooms?.length === 0 && <div style={{ font: "24px/36px Futura Hv BT", color: "var(--lightGray)", textAlign: "center", marginTop: 0 }}>
                                        {pastDate ? "Check-in date has passed. Please select a future date." : "There are no rooms available at these dates"}
                                    </div>}
                                    {showRooms && hotelRooms && sortedRooms?.map((room, idx) => {

                                        newRoom = (currRoomId !== room.id)
                                        prevRoomId = newRoom ? currRoomId : prevRoomId
                                        currRoomId = newRoom ? room.id : currRoomId
                                        prevOptionsNum = newRoom ? optionNo : optionNo + 1
                                        optionNo = newRoom ? 1 : optionNo + 1


                                        const ppn_book_bundle = room.ppn_book_bundle;

                                        // if(room.rate_type === "SMOP"){
                                        //     console.log(room,"room") 
                                        // }


                                        const averageSleeps = room?.rate_data?.reduce((total, next) => total + next?.occupancy_limit, 0) / room?.rate_data?.length;

                                        const titleArray = room?.title.split(',');
                                        const roomName = titleArray ? titleArray[1] : null;

                                        const toggleRateLimit = () => {
                                            setSelectedOption((oldId) => {
                                                return idx === oldId ? null : idx;
                                            })

                                        }

                                        const photoIndex = photos && photos?.length > 0 ? randomIntFromInterval(0, photos?.length) : 1;



                                        return (<div key={idx} >
                                            {newRoom &&
                                                <React.Fragment>


                                                    <div style={{ width: "100%", height: 30, float: "none", clear: "both", borderBottom: idx !== 0 ? "2px solid rgb(232, 232, 232)" : "0px none", marginBottom: 15 }}></div>
                                                    <div style={{ font: "18px/24px Futura Hv BT", color: "#000000", marginBottom: 10 }}>{room?.title?.replace(".", "")}</div>
                                                    {room && room?.description && <div style={{ font: "16px/24px Futura Lt BT", color: "#929292", marginBottom: 10 }}>{room?.description?.replace(".", "")}</div>}
                                                    <div>
                                                        {/* {roomName && <React.Fragment>
                                            <FontAwesomeIcon icon={faBed} style={{ marginRight: "5px" }} />
                                            <span className={classes.optionsRooms}>{roomName + " bed"}</span>
                                        </React.Fragment>} */}
                                                        {room?.room_square_footage > 0 && <React.Fragment>
                                                            <FontAwesomeIcon icon={faRuler} style={{ marginLeft: "15px", marginRight: "5px" }} /><span className={classes.optionsRooms}>{room.room_square_footage + " sq ft"}</span>
                                                        </React.Fragment>}
                                                        {averageSleeps > 0 && <React.Fragment>
                                                            <FontAwesomeIcon icon={faUsers} style={{ marginLeft: "15px", marginRight: "5px" }} /><span className={classes.optionsRooms}>Sleeps {Math.round(averageSleeps)}</span>
                                                        </React.Fragment>}


                                                    </div>
                                                    {photos && photos?.length > 0 && <div style={{ width: widthContainer, position: "static", float: isMobile ? "none" : "left" }}>
                                                        <Image style={{ objectFit: "cover", objectPosition: "center", width: widthContainer, height: heightContainer }}
                                                            alt="establishment" src={photos[idx + 1] ||
                                                                "https://amhqajbken.cloudimg.io/v7/_muvestab_/000_c…on/grayBackgroundCamera.jpg?func=crop&w=359&h=300"}
                                                        />
                                                    </div>}


                                                </React.Fragment>
                                            }

                                            {room && room?.rate_data && room?.rate_data?.slice(0, selectedOption === idx ? room?.rate_data?.length : 2)?.map((rate, indexRate) => {
                                                const specialPrice = (isLoggedIn() || stayTrip || useSmop || useMobileSmop) && rate?.rate_type === "SMOP" && rate.benchmark_price_details ? true : false;
                                                const signInforSpecial = !isLoggedIn() && !stayTrip && !useSmop && !useMobileSmop && rate?.rate_type === "SMOP" && rate.benchmark_price_details ? true : false;


                                                let ratePriceText = useMobileSmop && specialPrice ? "mobile price" : specialPrice ? "müver special price" : signInforSpecial ? "sign in for müver special price" : "per night";

                                                let rateTextColor = specialPrice ? "#0D3A7D" : signInforSpecial ? "#19BC9B" : "#929292";

                                                let roomPrice = rate?.benchmark_price_details?.display_price;
                                                let roomDisplayPrice = rate.price_details.display_price;
                                                // let roomTax = rate?.price_details?.display_taxes;
                                                let roomTax = rate?.price_details?.mandatory_fee_details?.breakdown?.prepaid?.display_total;

                                                // if(useDiscount && indexRate === 0 && idx === 0 && rate?.rate_type !== "SMOP"){ //for cheapest rate
                                                if (useDiscount && rate?.rate_type !== "SMOP") { //for cheapest rate
                                                    roomPrice = (roomPrice - ((discountAmt / 100) * roomPrice))
                                                    roomDisplayPrice = (roomDisplayPrice - ((discountAmt / 100) * roomDisplayPrice))
                                                    roomTax = (roomTax - ((discountAmt / 100) * roomTax))
                                                }

                                                const amenityLength = rate?.rate_amenity_data?.length;
                                                const hasBreakfast = rate?.rate_amenity_data && rate?.rate_amenity_data?.includes("FREE BREAKFAST" || "Free Breakfast")
                                                const amenities = rate?.rate_amenity_data && hasBreakfast ? rate?.rate_amenity_data?.filter((item) => item?.toLowerCase() !== "free breakfast") : rate?.rate_amenity_data;
                                                const days = diffDays(hotel_form_state?.check_out, hotel_form_state.check_in) ?? 1;
                                                const taxes = Number(roomTax / days).toFixed(2);

                                                const postPaid = rate?.payment_type === "POSTPAID"
                                                const prePaid = rate?.payment_type === "PREPAID"


                                                return (
                                                    <div className={classes.optionBlock} key={indexRate} >

                                                        <div style={{ marginLeft: isMobile ? 0 : 20, marginTop: 10, font: "18px/28px Futura Hv BT", color: "#000000" }}>Option {indexRate + 1}</div>
                                                        {/* <div style={{ marginLeft: 20, width: "29%", display: "inline-block", verticalAlign: "top" }}>
                                            <div><span className={classes.optionsText}>{rate.title}</span></div>
                                            <div><span className={classes.optionsText}>{boardType[rate.board_type]}</span></div> 
                                        </div> */}
                                                        {<div style={{ width: "24%", marginLeft: isMobile ? 0 : 20, display: "inline-block", verticalAlign: "top" }}>
                                                            {rate.payment_type && <div><span className={classes.optionsText}>{rate.payment_type === "POSTPAID" ? "Pay later" : "Pay now"}</span></div>}
                                                            {hasBreakfast && <div><span className={classes.optionsText}>Free Breakfast</span></div>}
                                                            {rate.refund_type && <div><span className={classes.optionsText}>{rate.refund_type === "NONE" ? "Non-Cancellable" : "Cancellable"}</span></div>}
                                                            {rate.refund_type && <div><span className={classes.optionsText}>{rate.refund_type === "NONE" ? "Non-Refundable" : "Refundable"}</span></div>}
                                                            {rate.occupancy_limit > 0 && <div><span className={classes.optionsText}>Max Occupancy: {rate.occupancy_limit}</span></div>}

                                                        </div>}
                                                        <div className={classes.optionsText} style={{ width: "22%", marginLeft: isMobile ? 0 : 20, display: "inline-block", verticalAlign: "top", textTransform: "capitalize" }}>
                                                            {amenities !== undefined && amenities !== null && amenities?.length > 0 && amenities?.slice(0, amenityLimit).map((amenity, i) => {
                                                                return (<div key={i} style={{ textTransform: "capitalize" }}>{amenity?.toLowerCase()}</div>)
                                                            })}
                                                            {amenityLength > AMENITY_COUNT && <div onClick={() => {
                                                                changeAmenityLimit(amenityLimit === AMENITY_COUNT ? amenityLength : AMENITY_COUNT);
                                                            }} style={{ color: "var(--mainGreen)", cursor: "pointer", marginTop: 5, }}> {amenityLimit === AMENITY_COUNT ? "more" : "less"}</div>}
                                                        </div>






                                                        <div style={{ width: "100%", display: isMobile ? "block" : "flex", verticalAlign: "top", marginLeft: isMobile ? 0 : 20, marginTop: 15, marginBottom: isMobile ? 20 : 0 }}>
                                                            <div className={classes.optionsGreenText} style={{ width: '51%', float: isMobile ? 'none' : 'left', paddingTop: 20 }}>{rate.available_rooms ? `We have ${rate.available_rooms} rooms left` : ""}</div>
                                                            <div style={{ display: isMobile ? "block" : "inline-grid", width: isMobile ? "100%" : "27%", textAlign: 'right', paddingRight: 15, marginTop: isMobile ? -50 : -4 }}><span className={classes.optionsHdr}>

                                                                {specialPrice && <span style={{ font: "14px/28px Futura Lt BT", color: 'red', textDecoration: 'line-through', marginRight: 12 }}>{rate.price_details.display_symbol + (roomPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))}</span>}
                                                                {cachedSubtotal > 0 && idx === 0 && indexRate === 0 ?
                                                                    rate.price_details.display_symbol + (cachedSubtotal?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))
                                                                    :
                                                                    signInforSpecial ? rate.price_details.display_symbol + (roomPrice?.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ",")) : rate.price_details.display_symbol + (roomDisplayPrice.toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ","))}
                                                            </span>

                                                                {cachedTaxes > 0 && idx === 0 && indexRate === 0 ? <div className={classes.optionsText} style={{ marginTop: -6 }}>
                                                                    +{rate.price_details.display_symbol}{Number(cachedTaxes).toFixed(2)} taxes & fees</div> :

                                                                    taxes > 0 && <div className={classes.optionsText} style={{ marginTop: -6 }}>
                                                                        +{rate.price_details.display_symbol}{Number(taxes).toFixed(2)} taxes & fees</div>}
                                                                <div className={classes.optionsText} onClick={() => signInforSpecial ? openPopup() : null} style={{ color: rateTextColor, cursor: signInforSpecial ? "pointer" : "auto" }}>{ratePriceText}</div></div>


                                                            {<div>
                                                                {postPaid && <div className={classes.optionsGreenText} style={{ lineHeight: "10px" }}>Book now, pay later</div>}
                                                                <div onClick={() => signInforSpecial ? null : handleAddRoomToBooking({ lang, uuid, ppn_book_bundle: rate.ppn_bundle, booking_bundles, hotel_id, ...hotel_form_state, rate, room })
                                                                }
                                                                    className={classes.optionsBtn}
                                                                    style={{ opacity: signInforSpecial ? 0.4 : 1, marginLeft: isMobile ? "auto" : 0, display: "flex", height: 50, marginTop: 5 }} >Book <RightArrowIcon width={15} height={15} style={{ marginLeft: "40px" }} /></div>
                                                            </div>}

                                                        </div>



                                                    </div>
                                                )
                                            })}
                                            {room?.rate_data && room?.rate_data?.length > 2 && <div className="" style={{
                                                color: "var(--mainGreen)",
                                                marginLeft: isMobile ? 0 : 317, marginTop: isMobile ? 15 : "5px"
                                            }}>
                                                {selectedOption === idx && <div style={{ cursor: "pointer" }} onClick={() => toggleRateLimit()}> <CircleUpIcon /> Hide more options</div>}
                                                {selectedOption !== idx && <div style={{ cursor: "pointer" }} onClick={() => toggleRateLimit()}> <CircleDownIcon /> Show more options</div>}
                                            </div>}



                                        </div>)
                                    })}

                                </div>}
                    </div>
                    <div style={{ width: "100%", height: 0, float: "none", clear: "both" }}></div>
                </div>}


        </div>
    )
}

const mapStateToProps = (state) => ({

    establishment: state.FormBank.HotelSearch.establishment,
    hotel_form_state: state.FormBank.HotelSearch.hotel_form_state,
    isMobile: state.Setting.is_mobile,
    lang: state.Setting.lang,
    uuid: state.Member.authModal.uuid,
    member: state.Member,
    booking_bundles: state.FormBank.BookingPriceline.booking_bundles,
    switchFeatureContainer: state.FormBank.FeatureFormat,
    booking_info: state.FormBank.BookingPriceline.booking_info,
})

const mapDispatchToProps = {
    addBundleToHotelBooking: Actions.addBundleToHotelBooking,
    setHotelBookingState: Actions.setHotelBookingState,
    setOpenAuthModal: Actions.setOpenAuthModal,
    fetchMuvRooms: Actions.fetchMuvRooms,
    fetchMuvRoomsLight: Actions.fetchMuvRoomsLight,
    addToShoppingCart: Actions.addToShoppingCart,
    addHotelItemToCart: Actions.addHotelItemToCart
}

const Rooms = connect(mapStateToProps, mapDispatchToProps)(Rooms_)
export default Rooms


export const diffDays = (d1, d2) => {
    const date1 = new Date(d1);
    const date2 = new Date(d2);
    const diffTime = Math.abs(date2 - date1);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    return diffDays;
}